import React from 'react'

import { Box } from '@material-ui/core'

import { Container, ContentHeader, Tab } from 'components'
import SettingsAccount from './components/SettingsAccount'
import SettingsAddress from './components/SettingsAddress'
import SettingsTaxes from './components/SettingsTaxes'
import SettingsInvoice from './components/SettingsInvoice'
import SettingsWebhook from './components/SettingsWebhook'
import SettingsUsers from './components/SettingsUsers'
import SettingsNFe from './components/SettingsNFe'
import SettingsEmails from './components/SettingsEmails'
import SettingsProfiles from './components/SettingsProfiles'
import SettingsPaymentMethods from './components/SettingsPaymentMethods'
import SettingsPenalty from './components/SettingsPenalty'
import TabProvider from 'providers/TabProvider'
import usePermissions from 'hooks/usePermissions'
import { useWindowSize } from '@yapay/react-components'

const SettingsMain = () => {
  const permissions = usePermissions()
  const windowSize = useWindowSize()

  return (
    <Container>
      <ContentHeader title="Configurações" subtitle="Todas as" />

      <TabProvider defaultValue="general">
        <Tab.TabContainer
          orientation={windowSize.isDesktop ? 'vertical' : 'horizontal'}
        >
          <Tab.TabItem label="Geral" value="general">
            <Box mb={4}>
              <SettingsAccount.Main />
            </Box>
            <SettingsAddress />
          </Tab.TabItem>

          {permissions.permitted('show_setting') && (
            <Tab.TabItem label="Faturamento" value="invoice">
              <SettingsInvoice />
            </Tab.TabItem>
          )}

          {permissions.permitted('show_setting') && (
            <Tab.TabItem label="Webhook" value="webhook">
              <SettingsWebhook />
            </Tab.TabItem>
          )}

          {permissions.permitted('show_setting') && (
            <Tab.TabItem label="NFe" value="nfe">
              <SettingsNFe />
            </Tab.TabItem>
          )}

          {permissions.permitted('index_tax') && (
            <Tab.TabItem label="Impostos" value="taxes">
              <SettingsTaxes.Main />
            </Tab.TabItem>
          )}

          {permissions.isAdmin() && (
            <Tab.TabItem label="Perfis" value="profiles">
              <SettingsProfiles.Main />
            </Tab.TabItem>
          )}

          {permissions.isAdmin() && (
            <Tab.TabItem label="Controle de acesso" value="users">
              <SettingsUsers.Main />
            </Tab.TabItem>
          )}

          {permissions.permitted('index_email') && (
            <Tab.TabItem label="Emails" value="emails">
              <SettingsEmails.EmailsMain />
            </Tab.TabItem>
          )}

          {permissions.permitted('show_setting') &&
            permissions.permitted('update_setting') && (
              <Tab.TabItem label="Meios de pagamento" value="paymentMethods">
                <SettingsPaymentMethods.Main />
              </Tab.TabItem>
            )}

          <Tab.TabItem label="Juros e multa" value="penalty">
            <SettingsPenalty />
          </Tab.TabItem>
        </Tab.TabContainer>
      </TabProvider>
    </Container>
  )
}

export default SettingsMain
